import 'css-chunksrc/client/pages/utilityPage/projectPage/projectStatusesList/loader/status/styles.scss';export default {
  "status": "_status_1g1rd_1",
  "item": "_item_1g1rd_5"
};